var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud-table" },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { staticClass: "btn-container", attrs: { xs8: "" } },
            [
              _vm._t("buttons"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn-filter",
                  class: { active: _vm.showFilterActive }
                },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _vm.filters.length
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-refresh",
                              attrs: { slot: "activator", id: _vm.idFilter },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.filtrar()
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("filter_list")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.filters")))])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-refresh",
                      attrs: { slot: "activator", id: _vm.idRefresh },
                      nativeOn: {
                        click: function($event) {
                          return _vm.getData()
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("refresh")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
                ],
                1
              ),
              _vm._v(" "),
              _vm.selected.length === 0 && _vm.checkbox
                ? _c(
                    "v-chip",
                    { attrs: { label: "", outline: "", color: "warning" } },
                    [_c("strong", [_vm._v("SELECCIONE AL MENOS UN REGISTRO")])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selected.length && _vm.checkbox
                ? _c(
                    "v-chip",
                    { attrs: { label: "", outline: "", color: "info" } },
                    [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.selected.length) +
                            " REGISTRO" +
                            _vm._s(_vm.selected.length > 1 ? "S" : "") +
                            " SELECCIONADO" +
                            _vm._s(_vm.selected.length > 1 ? "S" : "")
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", "max-width": _vm.widthModal },
                  model: {
                    value: _vm.modal,
                    callback: function($$v) {
                      _vm.modal = $$v
                    },
                    expression: "modal"
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "crud-dialog" },
                    [
                      _vm._t("form", function() {
                        return [_vm._v("Agregue su formulario aquí")]
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs4: "" } }, [_vm._t("labels")], 2),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs12: "" } }, [_vm._t("details")], 2),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs12: "" } }, [_vm._t("logs")], 2),
          _vm._v(" "),
          _vm.filter
            ? _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _vm._t(
                    "filters",
                    function() {
                      return [
                        _c("v-text-field", {
                          attrs: {
                            "append-icon": "search",
                            label: "Buscar",
                            "single-line": "",
                            "hide-details": ""
                          },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ]
                    },
                    { search: _vm.search }
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.filters.length
            ? _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showFilterActive,
                            expression: "showFilterActive"
                          }
                        ],
                        staticClass: "filter-container"
                      },
                      [
                        _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("search")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.filters, function(filter) {
                          return !filter.show ||
                            (filter.show &&
                              _vm.search[filter.show[0]] === filter.show[1])
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: filter.type != "hidden",
                                      expression: "filter.type != 'hidden'"
                                    }
                                  ],
                                  key: filter.field,
                                  staticClass: "filter-item"
                                },
                                [
                                  filter.type == "text"
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: filter.label,
                                          "hide-details": "",
                                          maxlength: "200"
                                        },
                                        model: {
                                          value: _vm.search[filter.field],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.search,
                                              filter.field,
                                              $$v
                                            )
                                          },
                                          expression: "search[filter.field]"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  filter.type == "number"
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: filter.label,
                                          "hide-details": "",
                                          type: "number",
                                          onkeypress:
                                            "return event.charCode >= 48 && event.charCode <= 57"
                                        },
                                        model: {
                                          value: _vm.search[filter.field],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.search,
                                              filter.field,
                                              $$v
                                            )
                                          },
                                          expression: "search[filter.field]"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  filter.type == "select"
                                    ? _c("v-autocomplete", {
                                        attrs: {
                                          items: filter.items,
                                          label: filter.label,
                                          "item-text": "text",
                                          "item-value": "value",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.search[filter.field],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.search,
                                              filter.field,
                                              $$v
                                            )
                                          },
                                          expression: "search[filter.field]"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  filter.type == "boolean"
                                    ? _c("v-switch", {
                                        attrs: {
                                          slot: "activator",
                                          value: true,
                                          color: "info"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.changeVisible(
                                              _vm.items.item,
                                              _vm.items.item.id,
                                              "modulo",
                                              "EditModulo"
                                            )
                                          }
                                        },
                                        slot: "activator",
                                        model: {
                                          value: _vm.items.item.visible,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.items.item,
                                              "visible",
                                              $$v
                                            )
                                          },
                                          expression: "items.item.visible"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  filter.type == "hidden"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.search[filter.field],
                                            expression: "search[filter.field]"
                                          }
                                        ],
                                        attrs: { type: "hidden" },
                                        domProps: {
                                          value: _vm.search[filter.field]
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.search,
                                              filter.field,
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  filter.type == "date"
                                    ? _c(
                                        "v-menu",
                                        {
                                          ref: "search[filter.field + '-menu']",
                                          refInFor: true,
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            lazy: "",
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "full-width": "",
                                            "max-width": "290px",
                                            "min-width": "290px"
                                          },
                                          model: {
                                            value:
                                              _vm.search[
                                                filter.field + "-menu"
                                              ],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.search,
                                                filter.field + "-menu",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "search[filter.field + '-menu']"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              slot: "activator",
                                              label: filter.label,
                                              hint: "MM/DD/YYYY",
                                              "persistent-hint": "",
                                              "prepend-icon": "event"
                                            },
                                            on: {
                                              blur: function($event) {
                                                _vm.search[
                                                  filter.field
                                                ] = _vm.parseDate(
                                                  _vm.search[
                                                    filter.field + "-input"
                                                  ]
                                                )
                                              }
                                            },
                                            slot: "activator",
                                            model: {
                                              value:
                                                _vm.search[
                                                  filter.field + "-input"
                                                ],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.search,
                                                  filter.field + "-input",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "search[filter.field + '-input']"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-date-picker", {
                                            attrs: { "no-title": "" },
                                            on: {
                                              input: function($event) {
                                                _vm.search[
                                                  filter.field + "-menu"
                                                ] = false
                                              }
                                            },
                                            model: {
                                              value: _vm.search[filter.field],
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.search,
                                                  filter.field,
                                                  $$v
                                                )
                                              },
                                              expression: "search[filter.field]"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _c(
                          "v-tooltip",
                          { attrs: { bottom: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { slot: "activator", icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.filtrar()
                                  }
                                },
                                slot: "activator"
                              },
                              [_c("v-icon", [_vm._v("close")])],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Cerrar filtro/búsqueda")])
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.getHeaders,
              items: _vm.items,
              pagination: _vm.pagination,
              "total-items": _vm.totalItems,
              loading: _vm.loading,
              "select-all": _vm.checkbox,
              "item-key": "id",
              rowsPerPageText: _vm.$t("common.rowsPage"),
              noResultsText: "No se encontraron registros que coincidan",
              noDataText: "No hay resultados",
              "disable-initial-sort": true,
              rowsPerPageItems: _vm.rowsPerPageItems
            },
            on: {
              "update:pagination": function($event) {
                _vm.pagination = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "headerCell",
                  fn: function(props) {
                    return [
                      _c("v-tooltip", { attrs: { bottom: "" } }, [
                        _c(
                          "span",
                          { attrs: { slot: "activator" }, slot: "activator" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(props.header.text) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.header.text) +
                              "\n          "
                          )
                        ])
                      ])
                    ]
                  }
                },
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c(
                        "tr",
                        [
                          _vm.checkbox
                            ? _c(
                                "td",
                                [
                                  !props.item.hide
                                    ? _c("v-checkbox", {
                                        attrs: {
                                          primary: "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: props.selected,
                                          callback: function($$v) {
                                            _vm.$set(props, "selected", $$v)
                                          },
                                          expression: "props.selected"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t(
                            "items",
                            function() {
                              return [
                                _vm._v(
                                  "\n            Defina la lista de registros aquí\n          "
                                )
                              ]
                            },
                            { item: props.item }
                          )
                        ],
                        2
                      )
                    ]
                  }
                },
                {
                  key: "pageText",
                  fn: function(ref) {
                    var pageStart = ref.pageStart
                    var pageStop = ref.pageStop
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(pageStart) +
                          "-" +
                          _vm._s(pageStop) +
                          " " +
                          _vm._s(_vm.$t("common.of")) +
                          " " +
                          _vm._s(_vm.totalItems) +
                          "\n      "
                      )
                    ]
                  }
                }
              ],
              null,
              true
            ),
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee85022c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee85022c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/util/crud-table-sin-orden/CrudTable.vue
// module id = null
// module chunks = 